import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #ededed;
  padding: 24px;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: 24px;

  @media print {
    display: none;
  }
`;

export const Description = styled.p`
  font-size: 14px;
  color: #282828;
  text-align: center;
  width: 100%;
  max-width: 600px;
  line-height: 22px;
`;

export const Button = styled.button`
  color: #44adf8;
  border: 1px solid #44adf8;
  background-color: transparent;
  font-size: 14px;
  line-height: 22px;

  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
`;
